import React from 'react'; 
import {TextField, Tooltip} from "@mui/material";
import {ChangeEvent, useEffect, useRef, useState} from "react";
import {useBackend} from "../../../../../hooks/backend/useBackend.ts";
import {RootState, useAppSelector} from "../../../../../state/state.tsx";
import {BusinessLeadsType} from "../../../types/CampaignsTypes.ts";
import {format} from "date-fns";
import { selectEffectiveUID } from '../../../../../state/UserStatesV2/userSliceV2.ts';

export default function VerifiedLeadsRows({verifiedLeadDoc}:{verifiedLeadDoc: BusinessLeadsType}) {

    const inputRef = useRef<HTMLInputElement>();
    const dropdownRef = useRef(null)
    const [isTextFieldDisabled, setTextFieldDisabled] = useState(true);
    const [note, setNote] = useState("");
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    // setting the fields
    useEffect(() => {
        if(verifiedLeadDoc.notes){
            setNote(verifiedLeadDoc.notes)
        }
    }, [verifiedLeadDoc]);


    // OnChange Handlers

    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    function onChangeNote(event: ChangeEvent<HTMLInputElement>) {
        setNote(event.target.value);

    }


    function onClickEditNote() {
        setTextFieldDisabled(false);
    }

    async function onClickSaveNote() {
        await handleAPICall({notes: note,lastUpdateTime:new Date().toISOString()});
        setTextFieldDisabled(true);
    }

    async function markInterestedState(status:string) {

        await handleAPICall({status: status,lastUpdateTime:new Date().toISOString()})
        setDropdownVisible(false);

    }

    // Since State changes take a render to apply the changes

    useEffect(() => {
        if (!isTextFieldDisabled && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isTextFieldDisabled]);


    // API Call
    const serviceProviderId = useAppSelector(selectEffectiveUID);

    const {update} = useBackend(`/ServiceProviders/${serviceProviderId}/BusinessLeads/`)

    async function handleAPICall(fields: any) {
        update(verifiedLeadDoc.id, fields)
    }


    return (
        <tr>
            {/*<td className="size-px whitespace-nowrap">*/}
            {/*    <div className="ps-6 py-3">*/}
            {/*        <label htmlFor="hs-at-with-checkboxes-1" className="flex">*/}
            {/*            <input type="checkbox"*/}
            {/*                   className="shrink-0 border-gray-300 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"*/}
            {/*                   id="hs-at-with-checkboxes-1"/>*/}
            {/*            <span className="sr-only">Checkbox</span>*/}
            {/*        </label>*/}
            {/*    </div>*/}
            {/*</td>*/}

            <td className="h-px w-28 whitespace-nowrap">
                <div className="pl-6 py-3">
                    <span className="block text-sm text-cc_brand font-medium">{"#" + verifiedLeadDoc.campaignId}</span>

                </div>
            </td>

            <td className="size-px whitespace-nowrap  pl-6">
                <div className="ps-6 lg:ps-3 xl:ps-0 pe-6 py-3">
                    <div className="flex items-center gap-x-3">

                        <div className="grow">
                            <span className="block text-sm font-semibold text-gray-800">{verifiedLeadDoc.name}</span>
                            {/*<span*/}
                            {/*    className="block text-sm text-gray-500">christina@site.com</span>*/}
                        </div>
                    </div>
                </div>
            </td>
            <td className="h-px w-28 whitespace-nowrap">
                <div className="px-6 py-3">
                    <span className="block text-sm  text-gray-800">{verifiedLeadDoc.number}</span>

                </div>
            </td>
            <td className="size-px whitespace-nowrap">
                <div className="px-6 py-3">
                    {verifiedLeadDoc.status === "Interested" ? <span
                            className="py-1 px-2.5 inline-flex items-center gap-x-1 text-xs font-medium bg-teal-100 text-teal-800 rounded-full">
                        <svg className="size-2.5" xmlns="http://www.w3.org/2000/svg" width="16"
                             height="16"
                             fill="currentColor" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                        </svg>
                        Interested
                    </span> :
                        <span
                            className="py-1 px-2.5 inline-flex items-center gap-x-1 text-xs font-medium bg-red-100 rounded-full bg-red-500/10 text-red-500">
                      <svg className="size-2.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                           fill="currentColor" viewBox="0 0 16 16">
                        <path
                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                      </svg>
                      Not Interested
                    </span>
                    }
                </div>
            </td>
            <td className="size-px w-40 whitespace-nowrap">
                <div className="px-2 py-3">
                    <div
                        className="flex items-center text-sm gap-x-3 text-gray-800 w-full overflow-x-hidden overflow-ellipsis">
                        <TextField
                            onChange={onChangeNote}
                            inputRef={inputRef}
                            value={note}
                            size={"small"}
                            required={true}
                            id="Name"
                            disabled={isTextFieldDisabled}
                            fullWidth={true}
                            variant="standard"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: 'grey', borderRadius: '10px'// Default border color
                                    }, '&:hover fieldset': {
                                        borderColor: 'grey', // Border color on hover
                                    }, '&.Mui-focused fieldset': {
                                        borderColor: 'skyblue', // Border color when focused
                                    }, '& .MuiInputBase-input': {
                                        fontSize: '14px',
                                        color: 'rgba(31, 41, 55, 1)',
                                        // Setting font size
                                    },
                                }, fontWeight: 400,
                            }}
                        />
                        {isTextFieldDisabled && <Tooltip title={"Edit"} arrow>
                            <div onClick={onClickEditNote}
                                 className={"p-2 rounded-full justify-center items-center hover:bg-gray-100 cursor-pointer"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round" className="feather feather-edit-3">
                                    <path d="M12 20h9"></path>
                                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                </svg>
                            </div>
                        </Tooltip>}

                        {!isTextFieldDisabled && <Tooltip title={"Save"} arrow>
                            <div onClick={onClickSaveNote}
                                 className={"p-2 rounded-full justify-center items-center hover:bg-gray-100 cursor-pointer"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round" className="feather feather-save">
                                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                                    <polyline points="17 21 17 13 7 13 7 21"></polyline>
                                    <polyline points="7 3 7 8 15 8"></polyline>
                                </svg>
                            </div>
                        </Tooltip>}
                    </div>
                </div>
            </td>
            <td className="size-px whitespace-nowrap">
                <div className="px-6 py-3">
                    <span className="text-sm text-gray-500">{format(verifiedLeadDoc.shownInterestTime , "hh:mm a - MMMM d")}</span>
                </div>
            </td>
            <td className="size-px whitespace-nowrap">


                <div className="relative  inline-block" ref={dropdownRef}>
                    <button onClick={() => {
                        setDropdownVisible(true)
                    }} id="hs-table-dropdown-1" type="button"
                            className="hs-dropdown-toggle py-1.5 px-2 inline-flex justify-center items-center gap-2 rounded-lg text-gray-700 align-middle disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm "
                            aria-haspopup="menu" aria-expanded="false" aria-label="Dropdown">
                        <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg"
                             width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                             strokeLinejoin="round">
                            <circle cx="12" cy="12" r="1"/>
                            <circle cx="19" cy="12" r="1"/>
                            <circle cx="5" cy="12" r="1"/>
                        </svg>
                    </button>
                    {isDropdownVisible && (
                        <div
                            className="absolute -left-24  transition-[opacity,margin] duration opacity-100 block divide-y divide-gray-200 min-w-48 z-10 bg-gray-100 shadow-md rounded-lg mt-2 "
                            aria-labelledby="hs-as-table-table-filter-dropdown"
                        >
                            <div className="divide-y divide-gray-200 cursor-pointer z-10" onClick={() => {
                                markInterestedState(verifiedLeadDoc.status === "Interested" ? "Not Interested" : "Interested")

                            }}>

                                <label htmlFor="filter-published" className="flex py-2.5 px-3">
                                    <span
                                        className="ms-3 text-sm text-gray-800 cursor-pointer ">{verifiedLeadDoc.status === "Interested" ? "Mark as not Interested" : "Mark as  Interested"}</span>
                                </label>

                            </div>
                        </div>
                    )}
                </div>


            </td>
        </tr>
    )
}